export default `
<!-- Generator: Adobe Illustrator 27.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36.4 20.3" style="enable-background:new 0 0 36.4 20.3;" xml:space="preserve">
<style type="text/css">
	.st0{opacity:0.7;}
	.st1{fill:#EE0015;}
	.st2{fill:currentColor;}
	.st3{clip-path:url(#SVGID_00000168104320221186023890000017353395451094436238_);fill:#FFFFFF;}
	.st4{fill:#B30010;}
	.st5{fill:currentColor;}
</style>
<path class="st5" d="M0.2,1.6c0-0.8,0.7-1.5,1.5-1.5h13.9c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H1.7C0.8,3.1,0.2,2.4,0.2,1.6z
	 M0.2,9.1c0-0.8,0.7-1.5,1.5-1.5h11.2c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5H1.7C0.8,10.5,0.2,9.9,0.2,9.1z M16.6,16.5
	c0,0.8-0.7,1.5-1.5,1.5H1.7c-0.8,0-1.5-0.7-1.5-1.5S0.8,15,1.7,15h13.4C15.9,15,16.6,15.7,16.6,16.5z"/>
<path class="st5" d="M32.7,8.8c0,1.7-0.6,3.3-1.5,4.6l4.7,4.7c0.5,0.5,0.5,1.2,0,1.7c-0.5,0.5-1.2,0.5-1.7,0l-4.7-4.7
	c-1.3,0.9-2.9,1.5-4.6,1.5c-4.3,0-7.7-3.5-7.7-7.7s3.5-7.7,7.7-7.7S32.7,4.5,32.7,8.8z M24.9,14.2c3,0,5.4-2.4,5.4-5.4
	s-2.4-5.4-5.4-5.4s-5.4,2.4-5.4,5.4S22,14.2,24.9,14.2z"/>
</svg>
`;
